import React from 'react';
import { LoadingPage } from '../../Components/LoadingOverlay';
import { UnexpectedError } from '../Shared';
import { useBeaconPageLogic } from './hooks/useBeaconPageLogic';
import { BeaconTabsView } from './components/BeaconTabsView';

export const BeaconPage = () => {
  const vm = useBeaconPageLogic();

  if (vm.status === 'loading') {
    return <LoadingPage />;
  }

  if (vm.status === 'error') {
    return <UnexpectedError message={vm.errorMessage} />;
  }

  return (
    <BeaconTabsView tabs={vm.tabs} activeTabKey={vm.activeTabKey} onTabChange={vm.onTabChange} />
  );
};
